'use client';

import type { StoreApi, UseBoundStore } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';
import { safeLocalStorage } from '@/lib/browser/safe-local-storage';
import { createTrackedStore } from '@/lib/dev/zustand-registry';

interface FaucetCooldownState {
  cooldownEndsAtByAddress: Record<string, number>;
  setCooldownEndsAt: (walletAddress: string, endsAtMs: number) => void;
}

export const useFaucetCooldownStore: UseBoundStore<StoreApi<FaucetCooldownState>> =
  createTrackedStore<FaucetCooldownState>('useFaucetCooldownStore')(
    persist(
      (set) => ({
        cooldownEndsAtByAddress: {},
        setCooldownEndsAt: (walletAddress: string, endsAtMs: number): void => {
          set((state) => ({
            cooldownEndsAtByAddress: {
              ...state.cooldownEndsAtByAddress,
              [walletAddress]: endsAtMs,
            },
          }));
        },
      }),
      {
        // Versioned: a new key drops cooldowns remembered for a retired faucet mint.
        name: 'morfi-faucet-cooldowns-v2',
        partialize: (
          state: FaucetCooldownState,
        ): Pick<FaucetCooldownState, 'cooldownEndsAtByAddress'> => ({
          cooldownEndsAtByAddress: state.cooldownEndsAtByAddress,
        }),
        storage: createJSONStorage(() => safeLocalStorage),
      },
    ),
  );
